<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { api } from '../api.js'
import type { Item } from '../types.js'
const items = ref<Item[]>([])
const name = ref('')
const unit = ref('个')
const customUnit = ref('')
const editing = ref<Item | null>(null)
const error = ref('')
const units = ['个', '杯', '碗', '份', '袋', '笼', '斤']
async function load() {
  try { items.value = (await api<{ items: Item[] }>('/api/items')).items.filter(item => item.kind === 'sale') }
  catch (e) { error.value = (e as Error).message }
}
function edit(item: Item) {
  editing.value = item; name.value = item.name
  unit.value = units.includes(item.unit) ? item.unit : 'custom'; customUnit.value = item.unit
}
function reset() { editing.value = null; name.value = ''; unit.value = '个'; customUnit.value = '' }
async function save() {
  error.value = ''
  try {
    const payload = { kind: 'sale', name: name.value, unit: unit.value === 'custom' ? customUnit.value : unit.value, category: editing.value?.category ?? '', defaultPrice: '', fixedDaily: false }
    await api(editing.value ? `/api/items/${editing.value.id}` : '/api/items', { method: editing.value ? 'PATCH' : 'POST', operationId: crypto.randomUUID(), body: JSON.stringify({ ...payload, ...(editing.value ? { expectedVersion: editing.value.version, enabled: editing.value.enabled } : {}) }) })
    reset(); await load()
  } catch (e) { error.value = (e as Error).message }
}
async function toggle(item: Item) {
  try {
    await api(`/api/items/${item.id}`, { method: 'PATCH', operationId: crypto.randomUUID(), body: JSON.stringify({ expectedVersion: item.version, name: item.name, category: item.category, unit: item.unit, defaultPrice: '', fixedDaily: false, enabled: !item.enabled }) })
    await load()
  } catch (e) { error.value = (e as Error).message }
}
onMounted(load)
</script>
<template>
  <section class="library-section">
    <h1>售卖商品</h1>
    <form class="item-form" @submit.prevent="save">
      <label>商品名称<input v-model="name" placeholder="例如 豆浆、包子" required maxlength="80" /></label>
      <label>商品单位<select v-model="unit"><option v-for="value in units" :key="value">{{ value }}</option><option value="custom">自定义</option></select></label>
      <label v-if="unit === 'custom'">自定义单位<input v-model="customUnit" required maxlength="20" /></label>
      <button class="primary-button">{{ editing ? '保存商品' : '新增商品' }}</button>
      <button v-if="editing" type="button" class="text-button" @click="reset">取消编辑</button>
    </form>
    <p v-if="error" class="form-error">{{ error }}</p>
    <div class="item-list"><article v-for="item in items" :key="item.id" :class="{ disabled: !item.enabled }"><div><b>{{ item.name }}</b><small>{{ item.unit }}</small></div><div class="item-actions"><button @click="edit(item)">编辑</button><button @click="toggle(item)">{{ item.enabled ? '停用' : '启用' }}</button></div></article></div>
  </section>
</template>
